import { gql } from '@apollo/client'

export const FIND_ALL_FLASH_CARD_GROUP = gql`
  query findAllFlashCardGroup($query: FlashCardGroupQueryInput = {}) {
    findAllFlashCardGroup(query: $query) {
      count
      items {
        id
        title
        description
        color
        order
        icon
      }
    }
  }
`

export const CREATE_FLASH_CARD_GROUP = gql`
  mutation createFlashCardGroup($createFlashCardGroupInput: CreateFlashCardGroupInput!) {
    createFlashCardGroup(createFlashCardGroupInput: $createFlashCardGroupInput) {
      id
      title
      description
      color
      order
      icon
    }
  }
`

export const REMOVE_FLASH_CARD_GROUP = gql`
  mutation removeFlashCardGroup($removeFlashCardGroupId: String!) {
    removeFlashCardGroup(id: $removeFlashCardGroupId) {
      affected
    }
  }
`

export const UPDATE_FLASH_CARD_GROUP = gql`
  mutation updateFlashCardGroup($updateFlashCardGroupInputFieldName: UpdateFlashCardGroupInput!) {
    updateFlashCardGroup(updateFlashCardGroupInputFieldName: $updateFlashCardGroupInputFieldName) {
      id
    }
  }
`

export const BULK_UPDATE_FLASH_CARD_GROUP = gql`
  mutation bulkUpdateFlashCardGroup($bulkUpdateFlashCardGroupInput: [BulkUpdateFlashCardGroupInput!]!) {
    bulkUpdateFlashCardGroup(bulkUpdateFlashCardGroupInput: $bulkUpdateFlashCardGroupInput) {
      id
    }
  }
`

export const BULK_REMOVE_FLASH_CARD_GROUP = gql`
  mutation bulkRemoveFlashCardGroup($ids: [LinkFlashCardGroupInput!]!) {
    bulkRemoveFlashCardGroup(ids: $ids) {
      affected
    }
  }
`
